export default {
	title: 'Informe de Diagnóstico Mensual',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elemento(s) seleccionado(s)',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	sendEmail: 'Enviar Correo',
	sendEmailWithCount: 'Enviar Correo ({count})',
	noData: {
		title: 'Sin Informes de Diagnóstico Mensual',
		description: 'No se encontraron datos relevantes del informe de diagnóstico mensual'
	},
	reportCard: {
		coverAlt: 'Portada del Informe de Diagnóstico Mensual',
		author: 'Autor',
		approver: 'Aprobador',
		updateTime: 'Tiempo de Actualización'
	},
	status: {
		completed: 'Completado',
		editing: 'Editando'
	},
	actions: {
		upload: 'Cargar',
		download: 'Descargar',
		audit: 'Auditar',
		audited: 'Auditado',
		delete: 'Eliminar',
		sendEmail: 'Enviar Correo',
		batchDelete: 'Eliminar en Lote'
	},
	emailDialog: {
		title: 'Enviar Correo',
		ccPerson: 'Persona CC',
		selectCcPerson: 'Por favor seleccione la persona CC',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		selectReportWarning: 'Por favor seleccione informe de diagnóstico',
		selectCcPersonWarning: 'Por favor seleccione la persona CC',
		sendSuccess: 'Enviado exitosamente',
		deleteConfirm: '¿Está seguro de eliminar los {count} elementos seleccionados?',
		deleteSuccess: 'Eliminado exitosamente',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		fileUploadSuccess: 'Archivo cargado exitosamente',
		fileUploadError: 'Error al cargar el archivo',
		fileTypeError: '¡Solo se permiten archivos PDF y Word!',
		fileSizeError: '¡El tamaño del archivo no puede superar 10MB!',
		auditSuccess: 'Auditoría exitosa',
		auditWarning: 'Este informe ha sido completado',
		auditConfirm: '¿Está seguro de aprobar este informe?'
	},
	form: {
		fileName: 'Nombre del Informe',
		startTime: 'Tiempo de Inicio',
		endTime: 'Tiempo de Fin',
		title: 'Título',
		filePath: 'Ruta del Archivo',
		fileType: 'Tipo de Archivo',
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		attachment: 'Archivo Adjunto',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		add: 'Agregar',
		update: 'Actualizar',
		manualUpload: 'Carga Manual',
		systemGenerate: 'Generado por el Sistema'
	},
	table: {
		title: 'Título',
		fileName: 'Nombre del Informe',
		filePath: 'Ruta del Archivo',
		type: 'Tipo de Archivo',
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		updateTime: 'Tiempo de Actualización'
	}
}
